module.exports = __webpack_public_path__ + "images/plus-95654a5e380d47de578e1c2d2852b70b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/plus.svg
// module id = 231
// module chunks = 0